import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    width: '100%'
  }
}));
